export default "__VITE_ASSET__CokTRt7___"